





import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class CookiePolicy extends Vue {
  public get policyComponent() {
    return () => import(`@/components/cookiePolicy/CookiePolicy.${this.$i18n.locale}`);
  }
}
